<div class="container-fluid">

  <h4 id="upper">Titre des recettes nettes</h4>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-3 d-flex justify-content-between align-items-center">
            <div class="col-auto">
              <a href="javascript:void(0);" class="btn btn-primary mb-2" id="gras" (click)="openSynthese()">
                <i class="mdi mdi-chart-bar me-2"></i> Synthèses des recettes nettes
              </a>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4">
              <div class="d-flex justify-content-end align-items-center gap-2">
                <label class="mb-0">Mois</label>
                <select class="form-select form-select-sm" style="width: 180px;" [(ngModel)]="mois" (change)="loadData()">
                  <option *ngFor="let item of moisItems" [ngValue]="item.value">{{ item.label }}</option>
                </select>
                <input class="form-control form-control-sm" style="width: 280px;" [(ngModel)]="search"
                  (keyup.enter)="loadData()" placeholder="Rechercher un compte...">
                <button class="btn btn-info btn-sm" style="white-space: nowrap;" (click)="loadData()">
                  <i class="mdi mdi-magnify me-1"></i> Recherche
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light rwd-table">
                <tr>
                  <th style="width: 20px;"></th>
                  <th>Code</th>
                  <th>Compte budgétaire</th>
                  <th class="text-end">Prévision annuelle</th>
                  <th class="text-end">Titre des recettes nettes</th>
                  <th>Mois</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of paginatedProjets; let i = index">
                  <td></td>
                  <td>{{ item.code }}</td>
                  <td>{{ item.libelle }}</td>
                  <td class="text-end">{{ (item.prevision?.total_previsionnel || 0) | number:'1.0-0' }}</td>
                  <td class="text-end">{{ (item.titres?.[0]?.montant || 0) | number:'1.0-0' }}</td>
                  <td>{{ getMoisLabel(item.titres?.[0]?.periode) }}</td>
                  <td>
                    <button (click)="openModal(item)" type="button" class="btn btn-success btn-sm">
                      <i class="mdi mdi-cash-plus font-size-18 me-1"></i> Recette
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-center" *ngIf="!isLoading">
            <div class="container">
              <div class="row">
                <div class="text-center">
                  <h6 id="graycolor">chargement en cours</h6>
                  <div class="loader4"></div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="paginatedProjets.length === 0 && isLoading" class="d-flex justify-content-center">
            <h5 id="graycolor">Aucun titre de recette trouvé</h5>
          </div>

          <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #titreModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Saisir un titre de recette</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <form>
      <div class="row mb-3">
        <div class="form-group col-md-3">
          <label>Code</label>
          <input class="form-control" [value]="selectedCompte?.code" disabled>
        </div>
        <div class="form-group col-md-9">
          <label>Compte budgétaire</label>
          <input class="form-control" [value]="selectedCompte?.libelle" disabled>
        </div>
      </div>
      <div class="row mb-3">
        <div class="form-group col-md-4">
          <label>Mois</label>
          <input class="form-control" [value]="moisItems[mois - 1]?.label" disabled>
        </div>
        <div class="form-group col-md-4">
          <label>Prévision annuelle</label>
          <input class="form-control" [value]="selectedCompte?.prevision?.total_previsionnel || 0" disabled>
        </div>
        <div class="form-group col-md-4">
          <label>Total recettes <span class="text-danger">*</span></label>
          <input type="number" min="10000" class="form-control" [(ngModel)]="titreForm.montant" name="montant">
        </div>
      </div>
      <div class="text-end mt-3">
        <button (click)="modal.close()" type="button" class="btn btn-light ms-1">
          <i class="pi pi-times" style="color: #212529"></i> Annuler
        </button>&nbsp;
        <button (click)="save()" type="button" class="btn btn-success">
          <i class="pi pi-save" style="color: white"></i> Valider
        </button>
      </div>
    </form>
  </div>
</ng-template>

<p-confirmDialog></p-confirmDialog>
<p-toast position="center"></p-toast>
<ngx-ui-loader></ngx-ui-loader>
